import React from 'react'
import { SVGIcon } from '~/utils/types'


export const Calendar = (props: SVGIcon) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      d="M18.25 0c.414 0 .75.336.75.75L18.999 2h2.25C22.768 2 24 3.233 24 4.75v16.5c0 1.517-1.233 2.75-2.75 2.75H2.75C1.233 24 0 22.767 0 21.25V4.75C0 3.233 1.233 2 2.75 2H5V.75c0-.414.336-.75.75-.75s.75.336.75.75V2h10.999V.75c0-.414.337-.75.75-.75zm4.249 9.5h-21L1.5 21.25c0 .689.561 1.25 1.25 1.25h18.5c.689 0 1.25-.561 1.25-1.25L22.499 9.5zM5 3.5H2.75c-.689 0-1.25.56-1.25 1.25L1.499 8h21l.001-3.25c0-.69-.561-1.25-1.25-1.25h-2.251v1.75c0 .414-.335.75-.75.75-.413 0-.75-.336-.75-.75V3.5H6.5v1.75c0 .414-.336.75-.75.75S5 5.664 5 5.25V3.5z"
    />
  </svg>
)
